import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { BundleData } from 'client/bundles/types';

import EventsList from 'client/components/events-list';
import Seo from 'client/components/seo';

const bPageTitle = cn('page-title');

interface Props {
    data: BundleData;
}

export default class PresentationsPage extends Component<Props> {
    render() {
        const { presentations } = this.props.data;

        return (
            <>
                <Seo title={presentations.title} />

                <div>
                    <h1 className={bPageTitle({ type: 'border' })}>{presentations.title}</h1>

                    <EventsList
                        docsView="line"
                        docsTextUppercase
                        events={presentations.list}
                        />
                </div>
            </>
        );
    }
}
